// `timeZone` is for a date that is a calendar day rather than a moment — one
// read off a document is stored as its wall-clock fields in UTC, and shown in
// the reader's zone it lands a day early west of Greenwich.
const formatDate = (date: Date | string, timeZone?: string) => {
  const premiumExpiresDate = new Date(date);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...(timeZone ? { timeZone } : {})
  }).format(premiumExpiresDate);
};

export default formatDate;
